/**
 * Override `toJSON()` method to hide the object value in the Redux devtool.
 * This is to prevent the object from crashing the devtool.
 */
export function hideInDevtool(obj: any): void {
  if (obj) {
    obj.toJSON = () => ({ hidden: 'prevent devtool from crashing' })
  }
}
